module.exports = __webpack_public_path__ + "static/media/hello_img_5.899abc44.png";